import { render, staticRenderFns } from "./AnnouncementDec2023.vue?vue&type=template&id=ac39cb76&"
import script from "./AnnouncementDec2023.vue?vue&type=script&lang=js&"
export * from "./AnnouncementDec2023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports